// ADAM BOARD (Üst Yönetim)
export const boardMembers = [
  {
    title: "Dr.",
    name: "Mehmet Haydaroğlu",
    role: "President, Adam Board",
    photo: require("../assets/team/President.jpg")
  },
  {
    title: "King",
    name: "Zofoa Abubakar",
    role: "Director General, Adam Board",
    photo: require("../assets/team/Executive Diractor.jpg")
  },
  {
    title: "Dr.",
    name: "Ahmet Yücel",
    role: "Vice President, Adam Board",
    photo: require("../assets/team/Ahmet Yücel.jpg") // Yeni fotoğraf eklenecek
  },
  {
    title: "Mr.",
    name: "Chakir Riad I. Taher",
    role: "Governance Director, Adam Board",
    photo: require("../assets/team/Governnce Director.jpg")
  }
];

// Direktörler
export const teamMembers = [
  {
    title: "Dr.",
    name: "Hameed Fodaly",
    role: "Business Development & Investment Director",
    photo: require("../assets/team/Hameed Fodaly.jpg")
  },
  {
    title: "Dr.",
    name: "Samer Al Buni",
    role: "Financial & Admin Director",
    photo: require("../assets/team/Samer Al Buni.jpg") // Yeni fotoğraf eklenecek
  },
  {
    title: "Mr.",
    name: "Bab Weld Yaqob",
    role: "Legal & Audit Director",
    photo: require("../assets/team/Bab Weld Yaqob.jpg")
  },
  {
    title: "H.H.",
    name: "Seydou Zataou Aly",
    role: "International Relations Director",
    photo: require("../assets/team/Seydou Zataou Aly.jpg")
  },
  {
    title: "Dr.",
    name: "Nabil Albokairy",
    role: "Secretary General Director",
    photo: require("../assets/team/Nabil Albokairy.jpg") // Yeni fotoğraf eklenecek
  },
  {
    title: "Dr.",
    name: "Basim Sofuoğlu",
    role: "Adam Education Director",
    photo: require("../assets/team/Basim Safwan.jpg")
  },
  {
    title: "Dr.",
    name: "SOUFIANE EL HORMA",
    role: "Studies, Researches & Training Director",
    photo: require("../assets/team/Soufiane El Horma.jpg") // Yeni fotoğraf eklenecek
  },
  {
    title: "Dr.",
    name: "Jabir Suleiman",
    role: "Economic Planning Director",
    photo: require("../assets/team/Jabir Suleiman.jpg") // Yeni fotoğraf eklenecek
  },
  {
    title: "Dr.",
    name: "Ahmet Yücel",
    role: "Adam Foundation Director",
    photo: require("../assets/team/Ahmet Yücel.jpg")
  }
];

// CEO'lar (Sektör Bazlı)
export const Executivemanagers = [
  {
    title: "Eng.",
    name: "Khaled Aboubakar",
    role: "ADAM STORE CEO",
    photo: require("../assets/team/Khaled Aboubakr.jpg")
  },
  {
    title: "Dr.",
    name: "Najib Alsouidi",
    role: "ADAM INTERNATIONAL ACADEMY CEO",
    photo: require("../assets/team/Najib Alsouidi.jpg")
  },
  {
    title: "Eng.",
    name: "Said Al Mukhaini",
    role: "ADAM SOLUTIONS CEO",
    photo: require("../assets/team/Said Al Mukhaini.jpg")
  },
  {
    title: "Dr.",
    name: "Abdulnasir Munir",
    role: "ADAM BANK CEO",
    photo: require("../assets/team/Abdulnasir Munir.jpg")
  },
  {
    title: "Dr.",
    name: "Ali Dicko",
    role: "ADAM INDUSTRIES CEO",
    photo: require("../assets/team/Ali Dicko.jpg")
  },
  {
    title: "Eng.",
    name: "Adel Ismail",
    role: "ADAM EPCM CEO",
    photo: require("../assets/team/Adel Ismail.jpg")
  },
  {
    title: "Dr.",
    name: "Bilal S. Sangare",
    role: "ADAM ALLIANCE CEO",
    photo: require("../assets/team/Bilal Sangare.jpg")
  },
  {
    title: "Eng.",
    name: "Ahmet Haydaroğlu",
    role: "ADAM INNOVATION CEO",
    photo: require("../assets/team/Ahmet Haydaroğlu.jpg")
  },
  {
    title: "Eng.",
    name: "Abdullah Yücel",
    role: "ADAM FOUNDATION CEO",
    photo: require("../assets/team/Abdullah Yücel.jpg")
  }

];